<template>
  <custom-popup
    v-model="dialog"
    :cons="{ title: 'مشاور هوش مصنوعی متن پیامک', icon: 'mdi-magic' }"
    :loading.sync="loading"
    hide-confirm
    max-width="650"
    persistent
    scrollable
    @click="
      dialog = false;
      resetForm();
      saveDefaultDialogloading = false;
      loading = false;
    "
  >
    <v-card v-if="!showResult">
      <v-card-title class="mb-0">
        <v-alert border="left" color="#007bff" colored-border elevation="1">
          <ChatRobotIcon style="color: #007bff" />
          <p class="white-space-pre-wrap">
            نوع کسب و کار و نوع پیامک مورد نظر خود را وارد کنید تا هوش مصنوعی ما
            برایتان چند متن پیامک پیشنهاد کند.
          </p>
        </v-alert>
      </v-card-title>
      <div class="d-flex justify-center my-0">
        <v-tooltip bottom color="info">
          <template v-slot:activator="{ on, attrs }">
            <v-chip
              class="rounded-lg me-2 info--text"
              color="rgba(198, 198, 198, .3)"
              small
              v-bind="attrs"
              @click="showUpgrade = !showUpgrade"
              v-on="on"
            >
              <v-icon left small>mdi-creation-outline</v-icon>
              <span v-if="computedCurrentPackage">{{
                persian(computedCurrentPackage.count || "0")
              }}</span>
            </v-chip>
          </template>

          <span v-if="computedCurrentPackage">
            باقی مانده:
            {{ persian(computedCurrentPackage.count) }}
            بار ساخت متن پیشنهادی
            {{ computedCurrentPackage.free ? " - رایگان" : "" }}
          </span>
        </v-tooltip>
      </div>
      <v-card-text class="pt-0">
        <v-row class="ma-0">
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-text-field
              v-model="businessType"
              label="نوع کسب و کار"
              placeholder="مثال: دندانپزشک"
              outlined
              dense
            />
          </v-col>

          <v-col cols="12" sm="12" md="6" lg="6">
            <v-text-field
              v-model="smsType"
              label="نوع پیامک"
              placeholder="مثال: تبلیغاتی"
              outlined
              dense
            />
          </v-col>

          <v-col cols="12" sm="12" md="6" lg="6">
            <v-select
              v-model="numberChar"
              :items="smsLengthOptions"
              item-text="text"
              item-value="value"
              label="تعداد پیام"
              outlined
              dense
              menu-props="auto"
              hide-details
              prepend-inner-icon="mdi-message-text-outline"
            />
          </v-col>

          <v-col cols="12" sm="12" md="6" lg="6">
            <v-card-text class="mx-0 px-0">
              <div class="mb-3">
                (اختیاری) کلماتی که مهم است در متن پیامک شما باشد را به صورت
                جداگانه اضافه کنید.
              </div>

              <div
                v-for="(kw, i) in keywords"
                :key="i"
                class="d-flex align-center mb-2"
              >
                <v-text-field
                  v-model="keywords[i]"
                  :placeholder="`مثال: تخفیف`"
                  outlined
                  dense
                  hide-details
                  class="mr-2"
                />
                <v-btn icon small color="error" @click="removeKeyword(i)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>

              <v-btn small text class="btn-accept" outlined @click="addKeyword">
                <v-icon left small>mdi-plus</v-icon>
                افزودن کلمه کلیدی
              </v-btn>
            </v-card-text>
          </v-col>
        </v-row>
        <!-- دکمه تولید -->
        <div class="d-flex justify-center mt-6">
          <v-btn
            large
            class="btn-download"
            :loading="generating"
            :disabled="!businessType.trim() || !smsType.trim() || generating"
            @click="generateTexts"
          >
            <ChatRobotIcon style="color: #007bff" />
            تولید متن‌های پیشنهادی
          </v-btn>
        </div>
      </v-card-text>
    </v-card>

    <div v-if="showResult" class="d-flex align-center mb-4 rullback">
      <div
        class="d-flex justify-start align-center mb-4 ga-4 buttons-container"
      >
        <v-btn
          class="btn-download rounded-lg buttons-container"
          :loading="savingAll"
          :disabled="savingAll || !suggestedTexts.length"
          @click="saveAllAsDefault"
        >
          <v-icon left>mdi-content-save-all</v-icon>
          ذخیره همه متن‌ها به پیش‌فرض
        </v-btn>
        <v-btn
          class="btn-back rounded-lg buttons-container"
          @click="showResult = false"
        >
          <v-icon left>mdi-arrow-left</v-icon>
          بازگشت به فرم
        </v-btn>
      </div>
      <v-spacer />
      <!-- نتایج -->
      <div v-if="suggestedTexts.length && showResult" class="mt-0">
        <v-divider class="mb-0 pb-0" />
        <v-card-text class="text-h3 mb-2">
          متن‌های پیشنهادی ({{ persian(suggestedTexts.length) }})
        </v-card-text>

        <v-row class="ma-2">
          <v-col v-for="(item, idx) in suggestedTexts" :key="idx" cols="12">
            <v-card outlined class="mb-4 mx-2">
              <v-card-text class="py-4">
                <div class="text-bold white-space-pre-wrap">{{ item }}</div>
                <div class="text-caption grey--text mt-2">
                  ≈ {{ persian(countChars(item)) }} کاراکتر ({{
                    persian(getMessageCount(countChars(item)))
                  }}
                  صفحه)
                </div>
              </v-card-text>

              <v-card-actions class="pa-3 pt-0 buttons-container">
                <v-btn
                  class="btn-history rounded-lg buttons-container"
                  depressed
                  :loading="loaddefault"
                  @click="openSaveDefaultDialog(item)"
                >
                  <v-icon small>mdi-content-save-outline</v-icon>
                  ذخیره در متن پیشفرض
                </v-btn>
                <v-spacer />
                <v-btn
                  class="submit-btn rounded-lg buttons-container"
                  @click="selectText(item)"
                  depressed
                  :loading="loadselect"
                >
                  <v-icon small>mdi-check-circle-outline</v-icon>
                  انتخاب متن
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
    <custom-popup
      v-model="saveDefaultDialog"
      max-width="600"
      persistent
      :cons="{ title: 'ذخیره به عنوان متن پیش‌فرض', icon: 'save' }"
      :loading.sync="saveDefaultDialogloading"
      hide-confirm
      @click="dialog = false"
    >
      <v-card class="pa-2">
        <v-card-text>
          <v-text-field
            v-model="defaultTitle"
            label="عنوان متن پیش‌فرض"
            placeholder="مثال: تخفیف ویژه دندانپزشکی"
            outlined
            dense
            counter="50"
            :rules="[(v) => !!v || 'عنوان الزامی است']"
          ></v-text-field>
          <v-textarea
            v-model="textToSave"
            label="متن پیامک"
            outlined
            readonly
            rows="4"
            class="mt-4"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn-cancel" @click="saveDefaultDialog = false">
            <v-icon small>mdi-close</v-icon>
            انصراف
          </v-btn>
          <v-btn
            class="btn-download"
            :loading="saveDefaultDialogloading"
            :disabled="!defaultTitle.trim()"
            @click="confirmSaveAsDefault"
          >
            <v-icon small>mdi-content-save-outline</v-icon>
            ذخیره
          </v-btn>
        </v-card-actions>
      </v-card>
    </custom-popup>
    <togetherAiUpgradeNew
      v-model="showUpgrade"
      :current-package.sync="currentPackage"
      class="contentinfo"
    />
  </custom-popup>
</template>

<script>
import { mapGetters, mapActions } from "vuex/dist/vuex.common.js";
import ChatRobotIcon from "./ChatRobotIcon";
import { userStoreItem } from "@/Utilities/defaultSms";
import togetherAiUpgradeNew from "./togetherAiUpgradeNew";
export default {
  name: "AiTextSuggestDialog",
  components: {
    togetherAiUpgradeNew,
    ChatRobotIcon,
  },

  props: {
    value: Boolean,
    inputBox: Object,
  },

  data() {
    return {
      loadselect: false,
      loaddefault: false,
      savingAll: false,
      saveDefaultDialog: false,
      defaultTitle: "",
      textToSave: "",
      showResult: false,
      numberChar: 132, //two messages
      showUpgrade: false,
      currentPackage: {},
      loading: false,
      saveDefaultDialogloading: false,
      dialog: false,
      businessType: "",
      smsType: "",
      keywords: [""],
      proPanel: null,
      generating: false,
      localSuggestedTexts: [],
    };
  },

  watch: {
    value(val) {
      this.dialog = val;
      if (!val) {
        this.resetForm();
      }
    },
    dialog(val) {
      this.$emit("input", val);

      if (val && this.hasPreviousSuggestions) {
        this.businessType = this.previousInputs.businessType || "";
        this.smsType = this.previousInputs.smsType || "";
        this.numberChar = this.previousInputs.numberChar || 132;
        this.keywords = this.previousInputs.keywords.length
          ? [...this.previousInputs.keywords]
          : [""];

        this.showResult = true;
      }
    },
  },
  computed: {
    ...mapGetters("aiSmsSuggestions", [
      "hasPreviousSuggestions",
      "previousSuggestions",
      "previousInputs",
    ]),
    suggestedTexts: {
      get() {
        return this.showResult && this.hasPreviousSuggestions
          ? this.previousSuggestions
          : this.localSuggestedTexts;
      },
      set(val) {
        this.localSuggestedTexts = val;
      },
    },
    smsLengthOptions() {
      const options = [];
      const base = 70;
      const increment = 62;

      for (let i = 1; i <= 15; i++) {
        options.push({
          text: `${i} صفحه`,
          value: i === 1 ? base : base + (i - 1) * increment,
        });
      }
      return options;
    },
    computedCurrentPackage() {
      let packages = this.currentPackage;

      return packages.remaining instanceof Array
        ? packages.remaining.reduce((obj, curr) => {
            obj.free = false;

            if (!obj.hasOwnProperty("count"))
              obj.count = Number(curr.remaining);
            else obj.count += Number(curr.remaining);

            return obj;
          }, {})
        : {
            free: packages.package_id === null,
            count: packages.remaining,
          };
    },
    getPackage() {
      axios
        .get(this.$aiApi + "/packages/user/package", {
          headers: this.header(),
        })
        .then((data) => {
          this.currentPackage = data.data.data;
          if (!this.currentPackage.remaining) {
            this.showUpgrade = true;
          }
        })

        .catch((response) => {
          console.error(response);
        })
        .finally(() => {});
    },
  },

  methods: {
    ...mapActions("aiSmsSuggestions", ["saveSuggestions"]),
    async saveAllAsDefault() {
      if (!this.suggestedTexts.length) return;

      this.savingAll = true;

      const itemsToSave = this.suggestedTexts.map((text, index) => {
        const cleanText = text.trim();
        const finalText = cleanText.includes("لغو11")
          ? cleanText
          : cleanText + "\nلغو11";

        const shortText = finalText.replace(/لغو11/g, "").trim();
        const words = shortText.split(" ").slice(0, 8).join(" ");
        const title =
          words.length > 40 ? words.substring(0, 37) + "..." : words;

        return {
          title: `${title || "متن پیشنهادی"} ${index + 1}`,
          text: finalText,
          type: "generate",
        };
      });

      try {
        await userStoreItem(itemsToSave);

        this.$toast.success(
          `همه ${itemsToSave.length} متن با موفقیت ذخیره شدند.`,
        );
      } catch (err) {
        const msg =
          err.response?.data?.message || "خطا در ذخیره متن‌های پیش‌فرض";
        this.$toast.error(msg);
      } finally {
        this.savingAll = false;
      }
    },
    header() {
      let token = localStorage.getItem("id_token");
      return {
        Authorization: token ? `Bearer ${token}` : null,
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*",
        "Content-Type": "application/json",
      };
    },
    openSaveDefaultDialog(text) {
      // this.suggestText = true;
      this.textToSave = text.trim();
      this.defaultTitle = this.generateSmartTitle(text); // عنوان هوشمند پیشنهاد بده
      this.saveDefaultDialog = true;
    },

    // تولید عنوان هوشمند بر اساس متن
    generateSmartTitle(text) {
      const cleanText = text.replace(/لغو11/g, "").trim();
      const words = cleanText.split(" ").slice(0, 8).join(" ");
      const short = words.length > 40 ? words.substring(0, 37) + "..." : words;
      return short || "متن پیش‌فرض";
    },

    async confirmSaveAsDefault() {
      if (!this.defaultTitle.trim()) return;

      this.saveDefaultDialogloading = true;
      this.saveDefaultDialogloading = true;

      await userStoreItem({
        title: this.defaultTitle.trim(),
        text:
          this.textToSave + (this.textToSave.includes("لغو") ? "" : "\nلغو11"),
        type: "generate",
      })
        .then((response) => {
          this.title = undefined;
          this.text = undefined;
          this.description = undefined;

          this.$toast.success("متن با موفقیت به عنوان پیش‌فرض ذخیره شد.");
          this.saveDefaultDialog = false;
        })
        .catch((err) => {
          const msg = err.response?.data?.message || "خطا در ذخیره متن پیش‌فرض";
          this.$toast.error(msg);
          this.saveDefaultDialogloading = false;
        })
        .finally(() => {
          this.saveDefaultDialogloading = false;
          this.saveDefaultDialogloading = false;
        });
    },
    countChars(text) {
      return text ? text.length : 0;
    },
    getMessageCount(chars) {
      if (chars <= 70) return 1;
      return Math.ceil((chars - 70) / 62) + 1;
    },
    addKeyword() {
      this.keywords.push("");
    },
    removeKeyword(index) {
      this.keywords.splice(index, 1);
    },

    resetForm() {
      this.businessType = "";
      this.smsType = "";
      this.keywords = [""];
      this.proPanel = null;
      this.localSuggestedTexts = [];
      this.showResult = false;
      this.generating = false;
    },
    async generateTexts() {
      this.generating = true;
      this.showResult = false;
      this.localSuggestedTexts = [];
      let needPack = this.computedCurrentPackage.count === 0;
      console.log(needPack, "needp");
      const cleanKeywords = this.keywords.map((k) => k.trim()).filter(Boolean);

      const prompt = `شما یک متخصص حرفه‌ای بازاریابی پیامکی هستید.
لطفاً دقیقاً ۵ متن پیامک کوتاه، جذاب و مؤثر به زبان فارسی بنویسید.

نوع کسب‌وکار: ${this.businessType.trim()}
نوع پیامک: ${this.smsType.trim()}
حداکثر تعداد کاراکتر مجاز: ${this.numberChar}
حداقل تعداد کاراکتر مجاز: ${this.numberChar - 62}

${
  cleanKeywords.length
    ? "کلمات کلیدی اجباری که حتماً باید در متن باشد: " +
      cleanKeywords.join("، ")
    : ""
}

نکات خیلی مهم (حتماً رعایت کنید):
- هر متن را کوتاه و حداکثر ${this.numberChar} کاراکتر نگه دارید.
- هر جمله را در یک خط جداگانه بنویسید.
- در انتهای هر متن، دقیقاً عبارت "لغو11" را در یک خط کاملاً جداگانه و آخر قرار دهید.
- بین هر متن کامل با متن بعدی، دقیقاً یک خط خالی (دو \n) قرار دهید.
- از ایموجی‌های مناسب استفاده کنید.
- هیچ شماره‌گذاری، علامت لیست یا متن اضافی ننویسید.
- فقط ۵ متن بنویسید و هیچ چیز دیگری نگویید.

مثال فرمت خروجی دقیق:
متن اول جمله اول
متن اول جمله دوم
تخفیف ویژه!
لغو11

متن دوم جمله اول
...
لغو11`;
      try {
        const { data } = await this.$api.post(this.$aiApi + "/chat/tmp/chat", {
          model: "gpt-4o-mini",
          message: prompt,
        });

        let response = data?.choices?.[0]?.message?.content || data?.text || "";

        let blocks = response
          .split("\n\n")
          .map((block) => block.trim())
          .filter((block) => block.length > 0);

        const finalTexts = blocks.map((block) => {
          let lines = block
            .split("\n")
            .map((l) => l.trim())
            .filter((l) => l.length > 0);

          let lastLine = lines[lines.length - 1];
          if (
            lastLine &&
            (lastLine === "لغو11" || lastLine.includes("لغو11"))
          ) {
            return lines.join("\n");
          } else {
            return lines.join("\n") + "\nلغو11";
          }
        });

        this.localSuggestedTexts = finalTexts.slice(0, 5);
        this.saveSuggestions({
          suggestions: this.localSuggestedTexts,
          inputs: {
            businessType: this.businessType,
            smsType: this.smsType,
            numberChar: this.numberChar,
            keywords: cleanKeywords,
          },
        });

        if (this.localSuggestedTexts.length < 5) {
          this.$modal.error("تعداد متن‌های تولید شده کمتر از حد انتظار است.");
        }

        if (needPack && !data.package.remaining) {
          this.showUpgrade = true;
          this.$modal.error(
            "خطا در  استفاده از هوش مصنوعی",
            rest.message || "لطفا بسته خریداری کنید",
          );
        }

        if (this.localSuggestedTexts.length > 0) this.showResult = true;
        this.showResult = true;

        this.currentPackage = data.package;
      } catch (err) {
        //package not found
        // this.$modal.error("خطا", "خطا در ارتباط با هوش مصنوعی");
        let message = "خطا در ارتباط با هوش مصنوعی. لطفا مجدد تلاش کنید.";

        this.generating = false;
        if (err.response.status === 404) {
          this.$toast.error(
            "ساخت متن پیامک پیشنهادی با مشکل مواجه شد، لطفا بسته خریداری کنید مجدد تلاش کنید",
          );
          this.showUpgrade = err.response.status === 404;
        } else {
          this.$toast.error("خطا", message);
        }
        // this.showResult = true;
      } finally {
        this.generating = false;
      }
    },
    selectText(text) {
      if (!this.inputBox) {
        this.dialog = false;
        return;
      }

      let cleanText = text.trim();
      const hasCancel =
        /لغو\s*11\b/i.test(cleanText) || cleanText.includes("لغو11");

      if (!hasCancel) {
        cleanText = cleanText + "\nلغو11";
      }

      if (this.inputBox.$el) {
        const textarea = this.inputBox.$el.querySelector("textarea, input");
        if (textarea) {
          textarea.focus();
          textarea.value = cleanText;
          textarea.dispatchEvent(new Event("input", { bubbles: true }));
        }

        this.inputBox.lazyValue = cleanText;
      } else if (typeof this.inputBox.insertText === "function") {
        this.inputBox.insertText(cleanText);
      }

      this.dialog = false;

      this.$nextTick(() => {
        const el = this.inputBox.$el?.querySelector("textarea, input");
        el?.focus();
      });
      // this.showResult = false;
    },
  },
};
</script>

<style scoped>
.white-space-pre-line {
  white-space: pre-line;
}
.rullback {
  display: flex;
  flex-direction: column;
  justify-content: end !important;
  align-items: end !important;
}
.white-space-pre-wrap {
  white-space: pre-wrap;
  word-break: normal;
  hyphens: none;
}
.buttons-container {
  flex-direction: row;
}
@media (max-width: 600px) {
  .buttons-container {
    flex-direction: column;
    align-items: flex-end !important;
  }
  .buttons-container .v-btn {
    margin-bottom: 8px;
  }
}
.text-bold {
  font-weight: bold;
  font-size: larger;
}
.text-h3 {
  font-size: 2.7rem !important;
}
.buttons-container {
  flex-direction: row;
  justify-content: space-between;
}

@media (max-width: 600px) {
  .buttons-container {
    flex-direction: column !important;
  }
  .buttons-container .v-btn {
    width: 100% !important;
    margin-bottom: 8px !important;
  }
  .buttons-container .v-btn:last-child {
    margin-bottom: 0;
  }
}
</style>
